import { EventCustomRegFieldAvailValues } from '../../shared/custom-reg-fields/event-custom-reg-field-avail-values.model';
import { EventCustomRegFieldMin } from '../../shared/custom-reg-fields/event-custom-reg-field-min.model';
export class RegistrationCustomRegFieldResponse {
  public ResponseId: number;
  public EventCustomRegFieldId: number;
  public EventId: number;
  public ProfileId: number;
  public SignUpId: number;
  public AttendeeId: number;
  public Response: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public ChangedBy: string;
  public EventCustomRegFieldAvailValuesId: number;
  public RegistrationHeaderId: number;
  public AttendeeHeaderId: number;
  public Descr: string;
  public CustomField: EventCustomRegFieldMin;

  public constructor() {
    this.ResponseId = 0;
    this.EventCustomRegFieldId = 0;
    this.EventId = 0;
    this.ProfileId = 0;
    this.SignUpId = 0;
    this.AttendeeId = 0;
    this.Response = '';
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.ChangedBy = '';
    this.EventCustomRegFieldAvailValuesId = 0;
    this.RegistrationHeaderId = 0;
    this.AttendeeHeaderId = 0;
    this.Descr = '';
    this.CustomField = new EventCustomRegFieldMin();
  }
}
